module.exports = __webpack_public_path__ + "static/img/hatopress-jj-underdogs-painting-1.67f1271.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workshops/hatopress-jj-underdogs-painting-1.jpg
// module id = 179
// module chunks = 1